import { Source } from "../../../../../schema.dev-sdk-api-appsync.generated";

export type OverrideState =
	| "OVERRIDABLE"
	| "OVERRIDE_AT_POS"
	| "OVERRIDE_AT_SITE";

export function getSourceOverrideState(source?: Source): OverrideState {
	switch (source) {
		case Source.LINKLY:
		case Source.SDK:
		case Source.STANDALONE:
			return "OVERRIDABLE";
		case Source.ORACLE_POS:
		case Source.ZELLER_POS:
			return "OVERRIDE_AT_POS";
		case Source.IMPOS:
		case Source.HL_POS:
		case Source.TEVALIS_POS:
			return "OVERRIDE_AT_SITE";
		default:
			return "OVERRIDABLE";
	}
}
